"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../../createSvgIcon"));

var _Remind = _interopRequireDefault(require("@rsuite/icon-font/lib/legacy/Remind"));

// Generated by script, don't edit it please.
var Remind = (0, _createSvgIcon["default"])({
  as: _Remind["default"],
  ariaLabel: 'remind',
  category: 'legacy',
  displayName: 'Remind'
});
var _default = Remind;
exports["default"] = _default;
module.exports = exports.default;